import Vue from "vue";
import Vuex from "vuex";
import unicornStore from "./UniconStore";
import i_APC from "./i-APCStore";
import Noti from "./Notification";


Vue.use(Vuex);

/* eslint-disable */
export default new Vuex.Store({
  state: {
    isSidebarActive: false,
    themeColor: "#2962ff",

    mode: "light_mode",
  },
  mutations: {
    //This is for Sidbar trigger in mobile
    IS_SIDEBAR_ACTIVE(state, value) {
      state.isSidebarActive = value;
    },
    mode(state, value) {
      state.mode = value;
    },
  },
  actions: {
    setCookie({ dispatch, commit, getters }, { name, value, days }) {
      console.log(name, value, days);
      var expires = "";
      if (days) {
        var date = new Date();
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
        expires = "; expires=" + date.toUTCString();
      }
      document.cookie = name + "=" + (value || "") + expires + "; path=/";
    },
    getCookie({ dispatch, commit, getters }, name) {
      var nameEQ = name + "=";
      var ca = document.cookie.split(";");
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == " ") c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) {
          console.log(c.substring(nameEQ.length, c.length));
          return c.substring(nameEQ.length, c.length);
          // return "light_mode"
        }
      }
      return null;
    },
    eraseCookie({ dispatch, commit, getters }, name) {
      document.cookie =
        name + "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
    },
  },
  getters: {
    mode(state) {
      return state.mode;
    },
    IS_SIDEBAR_ACTIVE(state){
      return state.isSidebarActive;
    },
  },
  modules: {
    unicorn: unicornStore,
    i_APC: i_APC,
    noti:Noti,
  },
});
